const dataSourcePortal = {
  header: {
    title: "Data Provider Portal",
    subtitle: "Review data requests forwarded to you and upload datasets.",
  },
  tabs: {
    newRequests: "New Requests",
    newRequestsWithCount: "New Requests ({{n}})",
    accepted: "Accepted — Upload Needed",
    acceptedWithCount: "Accepted — Upload Needed ({{n}})",
    activityLog: "Activity Log",
  },
  errors: {
    loadForwardedFailed: "Failed to load forwarded requests",
    loadAcceptedFailed: "Failed to load accepted requests",
    loadActivityFailed: "Failed to load activity",
    loadDataFailed: "Failed to load data",
    acceptFailed: "Failed to accept request",
    declineFailed: "Failed to decline request",
  },
  meta: {
    researcher: "Researcher:",
    forwardedBy: "Forwarded by:",
    project: "Project:",
    datasetId: "Dataset ID:",
  },
  labels: {
    requestedFields: "Requested fields:",
    filterCriteria: "Filter criteria:",
    processingNotes: "Processing notes:",
    forwardingNote: "Forwarding note:",
    forwardedOn: "Forwarded {{date}}",
    forwardedBySuffix: " by {{name}}",
  },
  badges: {
    requestNumber: "Request #{{id}}",
  },
  actions: {
    processing: "Processing…",
    canProvide: "I Can Provide This",
    cannotProvide: "Cannot Provide",
    uploadDataFile: "Upload Data File",
  },
  forwardedTab: {
    empty: "No requests have been forwarded to you at this time.",
  },
  acceptedTab: {
    empty: "No accepted requests are awaiting a data upload.",
    emptyHint:
      "After you accept a forwarded request, it will appear here so you can upload the dataset.",
  },
  activityTab: {
    empty: "No activity recorded yet.",
    headers: {
      request: "Request",
      researcher: "Researcher",
      dataset: "Dataset",
    },
    confirmed: "Confirmed",
  },
};

export default dataSourcePortal;
